/* eslint-disable no-nested-ternary */
import {
 Dispatch,
 FC,
 SetStateAction,
 useEffect,
 useMemo,
 useState,
} from 'react'
import { Avatar, Card, Col, Modal, Radio, Row, Skeleton } from 'antd'
import { BtnAnch, globalConfirm } from 'components/elements/global'
import {
 useGetTwilioListQuery,
 useIntegrationQuery,
 useUnlinkFbPageMutation,
} from 'features/integration/api'
import { useFacebook, useLogin } from 'react-facebook'
import ListContentLayout from 'layout/ListContentLayout'
import TwlIntegrationCard from 'features/integration/components/TwlIntegrationCard'
import FbIntegrationCard from 'features/integration/components/FbIntegrationCard'
import { useAppDispatch } from 'hooks'
import { baseAPI } from 'api/baseApi'
import {
 IntegrationContext,
 TIntegrationContext,
} from 'features/integration/provider/IntegrationContext'

const Integrations: FC = () => {
 const { Meta } = Card

 const [showFbIntegration, setShowFbIntegration] = useState(false)
 const [showTwlIntegration, setShowTwlIntegration] = useState(false)

 //  const d = useAppDispatch()
 //  const { onboarding_settings } = useWebSettings()
 //  const { onBoardListingStatus } = onboarding_settings || {}

 const {
  data: twilioData,
  isLoading: twlIsLoading,
  isFetching: twlIsFetching,
 } = useGetTwilioListQuery()

 const {
  data: integrationData,
  isLoading,
  isFetching: fbIsFetching,
 } = useIntegrationQuery()
 const [unLinkfbPage] = useUnlinkFbPageMutation()
 const d = useAppDispatch()
 const [intItems, setIntItems] = useState(integrationData ?? [])
 useEffect(() => {
  setIntItems(integrationData ?? [])
 }, [integrationData])

 const handleUnlinkFbPage = async (
  page_id?: any,
  isMultiple?: boolean,
 ): Promise<void> => {
  globalConfirm({
   cancelText: 'No',
   okText: 'Yes',
   content: 'Are you sure want to remove this page?',
   onOk: async () => {
    await unLinkfbPage?.(isMultiple ? { type: 'multiple' } : { page_id })
    setIntItems((prv) => prv.filter((item) => item.page_id !== page_id))
    d(baseAPI.util.invalidateTags(['FB-INT_LIST']))
   },
  })
 }

 const { login } = useLogin()

 const refetch = async () => {
  Modal?.destroyAll()
  const response = await login({
   scope:
    'pages_read_engagement,leads_retrieval,pages_manage_metadata,pages_show_list,pages_manage_ads,ads_management,business_management',
  })
  handleSuccess(response, false)
 }

 const { init } = useFacebook()

 const containsItem = (item: any) => {
  for (let i = 0; i < intItems?.length; i++) {
   if (intItems?.[i].page_id === `${item.id}`) {
    return true
   }
  }
  return false
 }

 const handleSuccess = async (res?: any, firstTry?: boolean) => {
  const api = await init()
  const FB = await api?.getFB()
  if (res?.status === 'connected') {
   FB.api('/me/accounts', (accRes: any) => {
    if ((accRes?.data?.length === 0 || !accRes?.data) && firstTry) {
     Modal.confirm({
      className: 'mts-confirm',
      title: 'Something Went Wrong!',
      icon: (
       <div className="con-icon-block">
        <i className="far fa-exclamation-triangle" />
       </div>
      ),
      okButtonProps: {
       style: { display: 'none' },
      },
      content: (
       <p>
        Connection request failed! Please{' '}
        <BtnAnch className="colored-link-1" onClick={() => refetch()}>
         Click Here
        </BtnAnch>{' '}
        to resend the request.
       </p>
      ),
     })
    } else {
     //  if (!onBoardListingStatus?.facebook_integration) {
     //   d(baseAPI.util.invalidateTags(['WEB-SETTINGS']))
     //  }

     for (let j = 0; j < accRes?.data?.length; j++) {
      if (!containsItem(accRes?.data?.[j])) {
       const { access_token, id, name } = accRes?.data?.[j] || {}
       setIntItems((prv) => [
        ...prv,
        {
         page_access_token: access_token,
         page_id: id,
         page_name: name,
         status: 'Activate',
        },
       ])
      }
     }
    }
   })
  }
 }

 const IntegrationContextValue = useMemo(
  (): TIntegrationContext => ({
   fbIntegrationData: intItems,
   setFbIntegrationData: setIntItems,
   onDisconnectFb: handleUnlinkFbPage,
  }),
  [handleUnlinkFbPage, intItems],
 )

 return (
  <IntegrationContext.Provider value={IntegrationContextValue}>
   <div className="integration">
    <ListContentLayout title="Integration">
     <div className="intgr-container">
      <FbIntegrationCard
       isLoading={isLoading || fbIsFetching}
       data={intItems}
       onDisconnect={handleUnlinkFbPage}
       onConnect={() => setShowFbIntegration(true)}
      />
      <TwlIntegrationCard
       isLoading={twlIsLoading || twlIsFetching}
       data={twilioData}
      />
     </div>
    </ListContentLayout>
   </div>
  </IntegrationContext.Provider>
 )
}

export default Integrations
